module.exports = __webpack_public_path__ + "assets/media/3.12b07584.wav";